<template>
  <section ref="root" class="dc-container">
    <!-- 🌟 Magical Background: Sky with Many Ultra-Tiny Stars -->
    <div class="cielo-estrellado">
      <div
        v-for="i in 40"
        :key="'star-' + i"
        class="estrella"
        :style="getEstrellaStyle(i)"
      ></div>

      <div
        v-for="i in 15"
        :key="'flash-' + i"
        class="destello"
        :style="getDestelloStyle(i)"
      ></div>
    </div>

    <!-- torn paper -->
    <div class="rasgado rasgado-top"></div>

    <!-- CONTENT -->
    <div class="dc-card">

      <!-- Title in two lines -->
      <h2 ref="title" class="dc-title">
        <span>Dress</span><br />
        <span class="script">Code</span>
      </h2>

      <!-- Label -->
      <div ref="badge" class="dc-badge">FORMAL</div>

      <!-- Dress / Suit Illustration -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Dress Code"
        class="dc-figure"
      />

      <!-- Color Palette in PNG -->

      <!-- Note -->
      <p ref="note" class="dc-note">
        Blue is reserved exclusively for the Quinceañera.
      </p>

      <img
        ref="palette"
        src="@/assets/pale.png"
        alt="Color Palette"
        class="dc-palette"
      />

    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const palette = ref(null)
    const note = ref(null)

    let stInstance = null

    const pseudoRandom = (seed) => {
      const x = Math.sin(seed) * 10000
      return x - Math.floor(x)
    }

    // Estilos para micro-estrellas ultra chiquititas (0.8px a 1.5px)
    const getEstrellaStyle = (i) => {
      const top = (pseudoRandom(i * 1.3) * 100).toFixed(1) + '%'
      const left = (pseudoRandom(i * 2.7) * 100).toFixed(1) + '%'
      const size = (pseudoRandom(i * 3.1) * 0.7 + 0.8).toFixed(1) + 'px'
      const dur = (pseudoRandom(i * 4.2) * 2 + 1.2).toFixed(1) + 's'
      const delay = (pseudoRandom(i * 5.5) * 3).toFixed(1) + 's'

      return {
        top,
        left,
        width: size,
        height: size,
        animationDuration: dur,
        animationDelay: delay
      }
    }

    // Estilos para destellos blin-blin muy delicados
    const getDestelloStyle = (i) => {
      const top = (pseudoRandom(i * 7.1) * 90 + 5).toFixed(1) + '%'
      const left = (pseudoRandom(i * 8.9) * 90 + 5).toFixed(1) + '%'
      const scale = (pseudoRandom(i * 6.3) * 0.25 + 0.35).toFixed(2)
      const dur = (pseudoRandom(i * 9.4) * 2 + 2).toFixed(1) + 's'
      const delay = (pseudoRandom(i * 3.8) * 4).toFixed(1) + 's'

      return {
        top,
        left,
        transform: `scale(${scale})`,
        animationDuration: dur,
        animationDelay: delay
      }
    }

    onMounted(async () => {
      await nextTick()

      if (!root.value) return

      // Línea de tiempo consecutiva
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      if (title.value) {
        tl.from(title.value, {
          opacity: 0,
          y: -24,
          filter: 'blur(6px)',
          duration: 0.5,
          ease: 'power3.out'
        })
      }

      if (badge.value) {
        tl.from(
          badge.value,
          {
            opacity: 0,
            y: -16,
            scale: 0.98,
            duration: 0.45,
            ease: 'back.out(1.6)'
          },
          '>-0.1' // Inicia justo después del título
        )
      }

      if (figure.value) {
        tl.from(
          figure.value,
          {
            opacity: 0,
            scale: 0.9,
            duration: 0.5,
            ease: 'power2.out'
          },
          '>-0.05' // Inicia tras la etiqueta
        )
      }

      // Animación consecutiva para la imagen de la paleta
    

      if (note.value) {
        tl.from(
          note.value,
          {
            opacity: 0,
            y: 14,
            duration: 0.4,
            ease: 'power2.out'
          },
          '>-0.05' // Inicia al finalizar la paleta
        )
      }
        if (palette.value) {
        tl.from(
          palette.value,
          {
            opacity: 0,
            y: 18,
            scale: 0.95,
            duration: 0.5,
            ease: 'power2.out'
          },
          '>-0.05' // Inicia justo después de la figura principal
        )
      }
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      ScrollTrigger.refresh()
    })

    return {
      root,
      title,
      badge,
      figure,
      note,
            palette,

      getEstrellaStyle,
      getDestelloStyle
    }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #f3f7fd;
  padding: 34px 18px 42px;
  margin-top: -42px;
  overflow: hidden;
  text-align: center;
}

/* ✨ CIELO ESTRELLADO ULTRA CHIQUITITO */
.cielo-estrellado {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.estrella {
  position: absolute;
  background-color: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 2px rgba(255, 255, 255, 0.9), 0 0 4px rgba(212, 235, 255, 0.6);
  animation: titilar infinite ease-in-out;
  will-change: opacity, transform;
}

@keyframes titilar {
  0%, 100% {
    opacity: 0.15;
    transform: scale(0.6);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

.destello {
  position: absolute;
  width: 6px;
  height: 6px;
  animation: blinBlin infinite ease-in-out;
  will-change: transform, opacity;
}

.destello::before,
.destello::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  background: #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 4px #ffffff, 0 0 7px #9dd4ff;
  transform: translate(-50%, -50%);
}

.destello::before {
  width: 100%;
  height: 1px;
}

.destello::after {
  width: 1px;
  height: 100%;
}

@keyframes blinBlin {
  0%, 100% {
    opacity: 0;
    transform: scale(0.2) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.1) rotate(90deg);
  }
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #f3f7fd;
  z-index: 2;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 3;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #0d0c4e;
  margin: 0 0 16px;
  line-height: 1.05;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.dc-title .script {
  font-weight: 400;
  opacity: 0.9;
}

.dc-badge {
  display: inline-block;
  background: url('@/assets/dorado.jpg') center center / cover no-repeat;
  color: #091448;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  height: auto;
  display: block;
  margin: 10px auto 12px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.25));
}

/* Estilos de la paleta */
.dc-palette {
  max-width: 240px;
  width: 80%;
  height: auto;
  display: block;
  margin: 14px auto 10px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 18px;
  color: #0f1e5b;
  opacity: 0.9;
  font-style: italic;
  margin: 10px auto 18px;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}
</style>